import script from "./textIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./textIndicator.vue?vue&type=script&setup=true&lang=js"

import "./textIndicator.vue?vue&type=style&index=0&id=4cde3466&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cde3466"]])

export default __exports__